import React from 'react';
import '../less/atb.less';
import Banner from "../../../auxiliary-components/shared/Banner";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import Table from "../../../auxiliary-components/shared/Table";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import Calculator from "../../../auxiliary-components/Calculator";
import Order from "../../Cards/views/orderAction";
import DownloadApp from "../../Cards/views/downloadApp.c";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import banner_img from '../img/banner_img.png';
import ATB_logo from '../img/ATB_logo.png';
import usage_block_data from "../enums/usage_block_data.json";
import card_order_img from "../img/card_order_img.png";
import share_icon from "../../Cards/ProjectSupport/img/share_icon.svg";
import table_data from "../enums/table_data.json";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import clearBR from 'utils/clearBR';
import loyalty_discount_img from '../img/loyalty_discount_img.png';
import card_issue_img_1 from '../img/card_issue_img_1.png';
import card_issue_img_2 from '../img/card_issue_img_2.png';
import card_issue_img_3 from '../img/card_issue_img_3.png';
import partners_img_1 from '../img/partners_img_1.png';
import partners_img_3 from '../img/partners_img_3.png';
import partners_img_4 from '../img/partners_img_4.png';
import scrollToOrder from 'utils/scrollToOrder';
import { downloadA24 } from "../../../services/urls/urls";
import how_to_1 from "../img/how_to_1.png";
import how_to_2 from "../img/how_to_2.png";
import how_to_3 from "../img/how_to_3.png";
import how_to_4 from "../img/how_to_4.png";
import HowToBlock from "../../../auxiliary-components/shared/HowToBlock";
import QuestionsAdminBlock from "../../../auxiliary-components/shared/QuestionsAdmin";
import { Preloader } from "MWComponents";
import SliderComponent from "../../../auxiliary-components/shared/Slider";
import PromotionalOffer from '../../../auxiliary-components/shared/PromotionalOffer';
import DOMPurify from 'dompurify';
import {atbMarketPromo1, atbMarketPromo2} from '../../../services/urls/urls';

export default function template() {
  const isMobile = this.isViewportMobile(),
    isTablet = this.isViewportTablet(),
    page = 'atb',
    {viewport} = this.props,
    modes = [ {mode: 'info', title: 'ATB_CARD_NAV_TITLE_1'},
      {mode: 'tariffs', title: 'ATB_CARD_NAV_TITLE_2'},
      {mode: 'loyalty', title: 'ATB_CARD_NAV_TITLE_4'},
      {mode: 'questions', title: 'ATB_CARD_NAV_TITLE_3'}],
    howToItems = [
      { img: how_to_1, title: 'ATB_CARD_HOW_TO_TITLE_1', text: 'ATB_CARD_HOW_TO_TEXT_1' },
      { img: how_to_2, title: 'ATB_CARD_HOW_TO_TITLE_2', text: 'ATB_CARD_HOW_TO_TEXT_2' },
      { img: how_to_3, title: 'ATB_CARD_HOW_TO_TITLE_3', text: 'ATB_CARD_HOW_TO_TEXT_3' },
      { img: how_to_4, title: 'ATB_CARD_HOW_TO_TITLE_4', text: 'ATB_CARD_HOW_TO_TEXT_4' }
    ],
    model = this.getModel(),
    isUtm = this.props.location.search.indexOf('utm_') !== -1,
    calculator = !model.creditSum ? (
      ''
    ) : (
      <div className="credit-calculator">
        <div className="calculator-wrapper">
          <Calculator model={this.getModel()} type="credit_cards" cardType='atb' {...this.props} />
        </div>
      </div>
    ),
    orderCards = (
      <div className="card-order-wrapper" id='order'>
        <div className="left-side">
          <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
          <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
          <div className="card-order">
            <div className="order-wrapper green-card">
              <Order
                {...this.props}
                row={!isMobile}
                utmParams={this.utmParams}
                type="atb"
              />
            </div>
          </div>
        </div>
        <img className="order-img" alt="card_order_img" src={card_order_img}></img>
      </div>
    ),
    app = isMobile && isUtm ?
      (
        <div className="content">
          {orderCards}
        </div>
      )
      :
      (<div className="download-app-wrapper" id='order'>
        <DownloadApp {...this.props}/>
      </div>);
  return (
    <div className="atb-card">
      <div className='slider-container'>
        {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
      </div>
      <TabsNew modes={modes} isMobile={isMobile} page={page} toggle={this.toggleMode} mode={this.state.mode}>
        <div className="wrapper" type={modes[0].mode}>
          <div className="content">
            <PromotionalOffer isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'promotion_offer')}/>
            <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-2"></UsageBlock>
            <div className="partners">
              <div className="partners__left left-partners">
                <div className="left-partners__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_1'))}}></div>
                <div className="left-partners__image">
                  <img src={partners_img_3} alt="image partners 1" />
                </div>
                <div className="left-partners__text" dangerouslySetInnerHTML={{ __html: isTablet || isMobile ? DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_2_MOB')) : DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_2_DESC'))}}></div>
                <div className="left-partners__button" onClick={() => window.open(atbMarketPromo1, '_blank')}>
                  <button dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ATB_CARD_STRONG_DISCOUNTS_BUTTON'))}}></button>
                </div>
              </div>
              <div className="partners__right right-partners">
                <div className="right-partners__title" dangerouslySetInnerHTML={{ __html: isTablet || isMobile ? DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_9_MOB')) : DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_9_DESC'))}}></div>
                <div className="right-partners__image">
                  <img src={partners_img_4} alt="image partners 1" />
                </div>
                <div className="right-partners__text" dangerouslySetInnerHTML={{ __html: isTablet || isMobile ? DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_10_MOB')) : DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_10_DESC'))}}></div>
                <div className="right-partners__button" onClick={() => window.open(atbMarketPromo2, '_blank')}>
                  <button dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_8'))}}></button>
                </div>
                <div className="right-partners__terms" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ATB_CARD_PARTNERS_TEXT_7'))}}></div>
              </div>
            </div>
            <div className='card-issue-title'>{this.l10n('ATB_CARD_ISSUE_TITLE_TEXT')}</div>
            <div className='card-issue'>
              <div className='card-issue-item'>
                <img src={card_issue_img_1} alt="card_issue_img_1" className='card-issue-item-img' />
                <div className='card-issue-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_1_TITLE')}}></div>
                <div className='card-issue-item-text' dangerouslySetInnerHTML={{__html: isMobile ? clearBR(this.l10n('ATB_CARD_ISSUE_ITEM_1_TEXT')) :  this.l10n('ATB_CARD_ISSUE_ITEM_1_TEXT')}}></div>
                <a href={downloadA24} className='card-issue-item-link' target='_blank' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_1_LINK')}}></a>
              </div>
              <div className='card-issue-item'>
                <img src={card_issue_img_2} alt="card_issue_img_2" className='card-issue-item-img' />
                <div className='card-issue-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_2_TITLE')}}></div>
                <div className='card-issue-item-text' dangerouslySetInnerHTML={{__html: isMobile ? clearBR(this.l10n('ATB_CARD_ISSUE_ITEM_2_TEXT')) : this.l10n('ATB_CARD_ISSUE_ITEM_2_TEXT')}}></div>
                <a href={'/branches'} className='card-issue-item-link' target='_blank' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_2_LINK')}}></a>
              </div>
              <div className='card-issue-item'>
                <img src={card_issue_img_3} alt="card_issue_img_3" className='card-issue-item-img thirth' />
                <div className='card-issue-item-title' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_3_TITLE')}}></div>
                <div className='card-issue-item-text' dangerouslySetInnerHTML={{__html: isMobile ? clearBR(this.l10n('ATB_CARD_ISSUE_ITEM_3_TEXT')) : this.l10n('ATB_CARD_ISSUE_ITEM_3_TEXT')}}></div>
                <a href={'https://www.google.com.ua/maps/search/%D0%90%D0%A2%D0%91'} className='card-issue-item-link' target='_blank' dangerouslySetInnerHTML={{__html: this.l10n('ATB_CARD_ISSUE_ITEM_3_LINK')}}></a>
              </div>
            </div>
            {isMobile ? '' : orderCards}
            {calculator}
          </div>
          {isMobile ? app : ''}
          <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>
        </div>
        <div className="wrapper" type={modes[1].mode}>
          <div className="content">
            <div className="table-wrap">
              <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
              <div className="tariffs-desc">
                {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                <a className="link" href={`https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_ATB_ua.pdf`} target="_blank">
                  {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                  <img alt="href_img" src={share_icon}></img>
                </a>
              </div>
            </div>
          </div>
          {app}
          <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>
        </div>
        <div className="wrapper" type={modes[2].mode}>
          <div className="content">
            <div className="loyalty-title">
              <div className="loyalty-title-text" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_TITLE_TEXT')}}></div>
              <div className="loyalty-title-desc" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_TITLE_DESC')}}></div>
            </div>
            <div className="loyalty-discount">
              <div className="loyalty-discount-text" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_TEXT')}}></div>
              <div className="loyalty-discount-desc" dangerouslySetInnerHTML={{__html:isMobile ? clearBR(this.l10n('ATB_CARD_LOYALTY_DISCOUNT_DESC')) : this.l10n('ATB_CARD_LOYALTY_DISCOUNT_DESC')}}></div>
              <img className="loyalty-discount-img" src={loyalty_discount_img} alt="loyalty_discount_img" />
            </div>
            <div className="loyalty-discount-instruction">
              <div className="loyalty-discount-instruction-text" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_INTSTRUCTION_TEXT')}}></div>
              <div className="loyalty-discount-instruction-desc" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_INTSTRUCTION_DESC')}}></div>
              <ul>
                <li className="loyalty-discount-instruction-desc" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_INTSTRUCTION_LIST_1')}}></li>
                <li className="loyalty-discount-instruction-desc" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_INTSTRUCTION_LIST_2')}}></li>
                <li className="loyalty-discount-instruction-desc" dangerouslySetInnerHTML={{__html:this.l10n('ATB_CARD_LOYALTY_DISCOUNT_INTSTRUCTION_LIST_3')}}></li>
              </ul>
            </div>
            <div className="how-to-block-wrapper">
              <div className="block-title">{this.l10n("ATB_CARD_HOW_TO_TITLE")}</div>
              <div className="block-text">{this.l10n("ATB_CARD_HOW_TO_TEXT")}</div>
              <HowToBlock data={howToItems} isMobile={isMobile} page={'green-card'}></HowToBlock>
            </div>
          </div>
        </div>
        <div className="wrapper" type={modes[3].mode}>
          <div className="content">
            <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
          </div>
          {app}
          <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>
        </div>
      </TabsNew>



          <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' || this.state.mode === 'loyalty' ? 'active' : 'hidden'}`} style={{marginBottom:-120}}>
              <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}></TextAboveFooter>
          </div>
        </div>
    );
}
